import React, { useEffect } from 'react';
import Toast from '../components/Toast.tsx';
import { removeToast } from '../store/index.ts';
import { useAppDispatch, useAppSelector } from '../store/hooks.ts';

function ToastContainer() {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.ui.toasts);

  useEffect(() => {
    const timers = toasts
      .filter((toast) => toast.autoDismiss)
      .map((toast) =>
        window.setTimeout(() => {
          dispatch(removeToast(toast.id));
        }, 4000)
      );

    return () => {
      timers.forEach((timerId) => window.clearTimeout(timerId));
    };
  }, [dispatch, toasts]);

  return (
    <Toast
      toasts={toasts}
      onDismiss={(id) => {
        dispatch(removeToast(id));
      }}
    />
  );
}

export default ToastContainer;
